export const warningMessages = {
  transactionsLimitWarning: 'Approaching the limit. {currency} {value} remaining.',
  transactionsLimitReached: 'Approaching the limit.',
  transactionsLimitExceeded: 'Exceeds your limit. Send up to {currency} {value}',
  transactionsLimitExceededCollection: 'Exceeds your limit. Collect up to {currency} {value}',
  amountExceedsWalletBalance: 'Amount exceeds wallet balance',
};
